import FieldsGeneratorRaw from './../../FieldsGenerator'
export default {
  mixins: [FieldsGeneratorRaw],
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: Object
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    },
    originModel: {
      type: Object
    }
  },
  model: {
    prop: 'modelProps',
    event: 'not-mutable'
  },
  data () {
    return {
    }
  },
  created () {

  },
  methods: {
    formatString (string) {
      // eslint-disable-next-line no-eval
      return eval(string)
    },
    async validate () {
      let vm = this
      Object.keys(this.config.items).forEach(element => {
        try {
          let obj = this.config.items[element]
          vm.$refs[`${vm._uid}${obj['fieldName'] ? obj['fieldName'] : ''}${element}`][0].validate()
        } catch (error) {
          console.log(error)
        }
      })
    }
  }
}
